import React from "react";
import { Link } from "react-router-dom";
import { Ticket, Calendar, Trophy } from "lucide-react";

export default function RaffleCard({ raffle }) {
  const sold = raffle.tickets_sold || 0;
  const total = raffle.total_tickets || 0;
  const pct = total ? Math.min(100, (sold / total) * 100) : 0;
  const remaining = total - sold;

  return (
    <Link
      to={`/raffles/${raffle.id}`}
      data-testid={`raffle-card-${raffle.id}`}
      className="fz-card block group"
    >
      <div className="aspect-[16/10] overflow-hidden border-b border-[#332D2B] relative">
        <img
          src={raffle.image_url}
          alt={raffle.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 bg-[#0F0C0B]/85 border border-[#C8A96A] px-3 py-1">
          <span className="font-mono-retro text-[10px] tracking-[0.3em] text-[#C8A96A] uppercase">Live Raffle</span>
        </div>
      </div>
      <div className="p-6 grid grid-cols-3 gap-4">
        <div className="col-span-2">
          <div className="font-mono-retro text-[10px] tracking-[0.3em] text-[#756F6B] uppercase">No. {String(raffle.id).slice(-6)}</div>
          <h3 className="font-display text-2xl text-[#F2EBDD] mt-1 leading-tight">{raffle.title}</h3>
          <div className="flex items-center gap-2 mt-3 text-[#A8A39D] text-sm">
            <Trophy size={14} className="text-[#C8A96A]" />
            <span className="line-clamp-1">{raffle.prize}</span>
          </div>
          <div className="flex items-center gap-2 mt-1 text-[#A8A39D] text-sm">
            <Calendar size={14} className="text-[#C8A96A]" />
            <span>Draws {raffle.draw_date}</span>
          </div>
        </div>
        <div className="stub-divider text-right">
          <div className="font-mono-retro text-[10px] tracking-[0.3em] text-[#756F6B] uppercase">Entry</div>
          <div className="font-display text-3xl text-[#C8A96A] leading-none">£{raffle.ticket_price}</div>
          <div className="font-mono-retro text-[10px] tracking-[0.3em] text-[#756F6B] uppercase mt-3">Left</div>
          <div className="font-display text-xl text-[#F2EBDD]">{remaining}</div>
        </div>
      </div>
      <div className="px-6 pb-6">
        <div className="h-1 bg-[#332D2B] w-full">
          <div className="h-full bg-[#C8A96A]" style={{ width: `${pct}%` }} />
        </div>
        <div className="mt-2 flex items-center justify-between font-mono-retro text-[10px] tracking-[0.25em] text-[#756F6B] uppercase">
          <span>{sold} / {total} sold</span>
          <span className="flex items-center gap-1 text-[#C8A96A]">
            <Ticket size={12} /> Enter Now
          </span>
        </div>
      </div>
    </Link>
  );
}
